<template>
    <div class="h-100 w-100" style="display:inline-block">
        <div style="height:50px;" class="comm-settings-top-nav">
            <div class="justify-content-start" style="width:100%;">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb comm-settings-top-nav m-0">
                        <li>
                            <back-button v-on:click.native="changeToSelectedSchedulerComponent('show-scheduler', true)" style="position: relative;"></back-button>
                        </li>
                        <li class="breadcrumb-item active-text-nav-bar mt-1" aria-current="page" style="font-size:17px;">{{selectedSchedulerName}}</li>
                    </ol>
                </nav>
            </div>
        </div>
        <div class="scheduler-main-wrapper w-100" :style="isScheduleEditMode?{'height':'100%'}:{'height':'calc(100% - 120px)'}" style="display:inlin-block;padding:0px 20px;overflow:auto">
            <div class="col-md-12 h-100">
                <div class="w-100 comm-field-div" :style="isScheduleEditMode?'margin:0px 0px 10px 0px':'margin:10px 0px;'" style="display:inline-block;padding:0px 20px;">
                    <h6 class="comm-scheduler-lable-style"> Name </h6>
                    <input v-if="!isScheduleEditMode" v-model="schedulerName" class="rounded text-light input-fields" type="text" placeholder="Scheduler Name" autocomplete="off" style="float:inline-start;width:50%;">

                    <div v-else style="width:80%;display: inline-block;height:40px;float:inline-start"> 
                        <div style="display: inline-block; height: 40px; float: inline-start; min-width: 50%;width: auto;max-width: 90%;">
                            <div v-if="isScheduleEditMode && !isEditable('schedule_task_name')"  class="edit-icon-visibility" style="float:inline-start;height:40px;display:inline-flex">
                                <span v-if="!isEditable('schedule_task_name')" :title="selectedSchedulerInfo.schedule_task_name" style="font-size: 16px; display: flex; position: relative;  margin-inline-end: 10px; word-break: break-word;align-items: center;">
                                    {{selectedSchedulerInfo.schedule_task_name}}
                                </span> 
                                <edit-icon
                                    @click.native="editSchedulerField('schedule_task_name'), schedulerNameEdited = selectedSchedulerInfo.schedule_task_name"
                                    v-if="isScheduleEditMode && !isEditable('schedule_task_name')"
                                    class="edit-icon"
                                ></edit-icon>

                            </div>
                            <input
                                minlength="3"
                                type="text"
                                v-model="schedulerNameEdited"
                                v-if="isScheduleEditMode && isEditable('schedule_task_name')"
                                class="rounded text-light comm-input-field-style review-heading-input"
                                :placeholder="$t('Scheduler Name')"
                                style="height: 40px;position: relative;font-size: 16px;width: 99% !important;float: inline-start;max-width: 99%;border: 1px solid #828282;padding-inline-start: 5px;"
                                required
                                />
                        </div>
                        <div v-if="isScheduleEditMode && isEditable('schedule_task_name')" class="taskTitleSaveUnsaveBtns" style="height: 40px;display: inline-block;float: inline-start;">
                            <div class="d-flex" style="height: 100%;align-items: center;">
                            <save-icon
                            @click.native="schedulerFieldUpdateRequest('schedule_task_name')"
                            ></save-icon>
                            
                            <cancel-icon
                                @click.native="cancelSelectedSchedulerFields('schedule_task_name')" >
                            </cancel-icon>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-100 comm-field-div" :style="isScheduleEditMode?'margin:0px 0px 10px 0px':'margin:10px 0px;'" style="display:inline-block;padding:0px 20px;">
                    <h6  class="comm-scheduler-lable-style"> {{$t('Service')}} </h6>
                    
                    <template v-if="!isScheduleEditMode">
                        <div style="width: 50%;display:inline-block;float:inline-start;">
                            <Multiselect
                                v-model="serviceName"
                                :options="schedulerClassServiceListForDropDown"
                                :searchable="true"
                                :close-on-select="true"
                                :allow-empty="false"
                                label="service_class_name"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                track-by="service_class_id"
                                @select="onClassServiceChange($event)"
                               
                                style="float:inline-start" 
                                >
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                        </div>
                    </template> 

                    <div v-else style="width:80%;display: inline-block;height:40px;float:inline-start"> 
                        <div style="display: inline-block;height:40px;float: inline-start;width:35%">
                            <div v-if="!isEditable('service_class')" class="edit-icon-visibility"  style="float:inline-start;height:40px;display:inline-flex">
                                <span :title="selectedSchedulerInfo.service_class.service_class_name" style="font-size: 16px; display: flex; position: relative;  margin-inline-end: 10px; word-break: break-word;align-items: center;">
                                    {{selectedSchedulerInfo.service_class.service_class_name}}
                                </span> 
                                <edit-icon
                                    @click.native="editSchedulerField('service_class'), schedulerServicenameEdited = selectedSchedulerInfo.service_class"
                                    v-if="!isEditable('service_class')"
                                    class="edit-icon"
                                ></edit-icon>

                            </div>
                            <Multiselect
                                v-if="isEditable('service_class')"
                                v-model="schedulerServicenameEdited"
                                :options="schedulerClassServiceListForDropDown"
                                :searchable="true"
                                :close-on-select="true"
                                :allow-empty="false"
                                label="service_class_name"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                track-by="service_class_id"
                                @select="onClassServiceChange($event)"
                                style="float:inline-start;" 
                                >
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                        </div>
                        <div v-if="isEditable('service_class')" class="taskTitleSaveUnsaveBtns" style="height: 40px;display: inline-block;float: inline-start;">
                            <div class="d-flex" style="height: 100%;align-items: center;">
                            <save-icon
                            @click.native="schedulerFieldUpdateRequest('service_class')"
                            ></save-icon>
                            
                            <cancel-icon
                                @click.native="cancelSelectedSchedulerFields('service_class')" >
                            </cancel-icon>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-100 comm-field-div" :style="isScheduleEditMode?'margin:0px 0px 10px 0px':'margin:10px 0px;'" style="display:inline-block;padding:0px 20px;">
                    <h6  class="comm-scheduler-lable-style"> {{$t('Execution Type')}} </h6>
                    <template v-if="!isScheduleEditMode">
                        <div style="width: 50%;display:inline-block;float:inline-start;">
                            <Multiselect
                                v-model="execution_type"
                                :options="executionTypesList"
                                :searchable="true"
                                :close-on-select="true"
                                :allow-empty="false"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                @select="onExecutionTypeChange($event)"
                               
                                style="float:inline-start;text-transform: capitalize;" 
                                >
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                        </div>
                    </template> 

                    <div v-else style="width:80%;display: inline-block;height:40px;float:inline-start"> 
                        <div style="display: inline-block;height:40px;float: inline-start;width:35%">
                            <div v-if="!isEditable('execution_type')" class="edit-icon-visibility"  style="float:inline-start;height:40px;display:inline-flex">
                                <span :title="selectedSchedulerInfo.execution_type" style="font-size: 16px; display: flex; position: relative;  margin-inline-end: 10px; word-break: break-word;align-items: center;text-transform: capitalize;">
                                    {{selectedSchedulerInfo.execution_type}}
                                </span> 
                                <edit-icon
                                    @click.native="editSchedulerField('execution_type'), executionTypeEdited = selectedSchedulerInfo.execution_type"
                                    v-if="!isEditable('execution_type')"
                                    class="edit-icon"
                                ></edit-icon>

                            </div>
                            <Multiselect
                                v-if="isEditable('execution_type')"
                                v-model="executionTypeEdited"
                                :options="executionTypesList"
                                :searchable="true"
                                :close-on-select="true"
                                :allow-empty="false"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                @select="onExecutionTypeChange($event)"
                                style="float:inline-start;text-transform: capitalize;" 
                                >
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                        </div>
                        <div v-if="isEditable('execution_type')" class="taskTitleSaveUnsaveBtns" style="height: 40px;display: inline-block;float: inline-start;">
                            <div class="d-flex" style="height: 100%;align-items: center;">
                            <save-icon
                            @click.native="schedulerFieldUpdateRequest('execution_type')"
                            ></save-icon>
                            
                            <cancel-icon
                                @click.native="cancelSelectedSchedulerFields('execution_type')" >
                            </cancel-icon>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-100 comm-field-div" :style="isScheduleEditMode?'margin:0px':'margin:10px 0px;'" style="display:inline-block;padding:0px 20px;">
                    <h6  class="comm-scheduler-lable-style" > {{$t('Schedule')}} </h6>  
                    <div class="scheduler-fields-wrapper" style="padding:0px 10px 10px 0px">
                         <div class="scheduler-each-field-wrapper">
                            <input v-model="scedulerTypevalue" @click="selectSchedulerType('every_day', true)" type="radio" id="every_day" ref="every_day" value="every_day" class="bg-transparent border rounded text-light bigger-checkboxes scheduler-comm-radio-btn" name="scheduler-value"/>
                            <span class="scheduler-comm-radio-label" for="every_day">{{$t('Every Day')}}</span>
                            <template v-if="!isScheduleEditMode && isEveryDaySelected">
                                <div style="margin-inline-start:25px;display:inline-flex;align-items:center">
                                    <span class="comm-at-label" style="float:inline-start">at</span>
                                    <Timepicker 
                                        v-if="isEveryDaySelected" 
                                        v-model="selectedEveryDayValue" 
                                        format="HH:mm" 
                                        close-on-complete 
                                        hour-label="hour" 
                                        minute-label="minute"
                                        style="float:inline-start;"
                                        ref="addEveryDayPicker"
                                    >
                                    </Timepicker>
                                    <span v-if="isEveryDaySelected"  style="margin: 0px 10px;font-size: 14px;color: #757575;"> hours</span>
                                </div>
                            </template>
                            <div v-else-if="isScheduleEditMode && isEveryDaySelected" style="width:80%;display: inline-block;height:40px;float:inline-start"> 
                                <div style="display: inline-flex;height:40px;float: inline-start;align-items: center;margin-inline-start: 25px;">
                                    <div class="d-inline-flex edit-icon-visibility" style="float:inline-start;">
                                        <span class="comm-at-label">at</span>
                                        <span v-if="!isEditable('every_day')" style="font-size: 16px; display: flex; position: relative; word-break: break-word;align-items: center;">
                                            {{getSchedulerTypeValue("every_day")}} <span v-if="!isEditable('every_day')" style="margin: 0px 10px;font-size: 14px;color: #757575;">hours</span>
                                        </span> 
                                        <edit-icon
                                            @click.native="editSchedulerField('every_day');"
                                            v-if="!isEditable('every_day')"
                                            class="edit-icon"
                                        ></edit-icon>

                                    </div>
                                    <Timepicker 
                                        v-if="isEditable('every_day')" 
                                        v-model="selectedEveryDayValue" 
                                        format="HH:mm" 
                                        close-on-complete 
                                        hour-label="hour" 
                                        minute-label="minute"
                                        auto-scroll
                                        style="float:inline-start;"
                                        ref="addEveryDayPicker"
                                    >
                                    </Timepicker>
                                    <span v-if="isEditable('every_day')" style="margin: 0px 10px;font-size: 14px;color: #757575;"> hours </span>
                                </div>
                                <div v-if="isScheduleEditMode && isEditable('every_day')" class="taskTitleSaveUnsaveBtns" style="height: 40px;display: inline-block;float: inline-start;">
                                    <div class="d-flex" style="height: 100%;align-items: center;">
                                    <save-icon
                                    @click.native="schedulerFieldUpdateRequest('every_day')"
                                    ></save-icon>
                                    
                                    <cancel-icon
                                        @click.native="cancelSelectedSchedulerFields('every_day')" >
                                    </cancel-icon>
                                    </div>
                                </div>
                            </div> 
                        </div>
                        <div class="scheduler-each-field-wrapper">
                            <input v-model="scedulerTypevalue" @click="selectSchedulerType('every_hour', true)" type="radio" id="every_hour" ref="every_hour" value="every_hour" class="bg-transparent border rounded text-light bigger-checkboxes scheduler-comm-radio-btn" name="scheduler-value"/>
                            <span class="scheduler-comm-radio-label" for="every_hour">{{$t('Every Hour')}}</span>
                            <template v-if="!isScheduleEditMode && isEveryHourSelected">
                                <div style="margin-inline-start:25px;display:inline-flex;align-items:center">
                                    <span class="comm-at-label" style="float:inline-start">at</span>
                                    <Timepicker 
                                        v-if="isEveryHourSelected" 
                                        v-model="selectedEveryHourValue" 
                                        format="mm" 
                                        close-on-complete
                                        minute-label="minute"
                                        style="float:inline-start;"
                                        ref="addEveryHourPicker"
                                    >
                                    </Timepicker>
                                    <span v-if="isEveryHourSelected"  style="margin: 0px 10px;font-size: 14px;color: #757575;"> min</span>
                                </div>
                            </template>
                            <div v-else-if="isScheduleEditMode && isEveryHourSelected" style="width:80%;display: inline-block;height:40px;float:inline-start"> 
                                <div style="display: inline-flex;height:40px;float: inline-start;align-items: center;margin-inline-start: 15px;">
                                    <span class="comm-at-label">at</span>
                                    <div v-if="!isEditable('every_hour')" class="d-inline-flex edit-icon-visibility" style="float:inline-start;">
                                         <span v-if="!isEditable('every_hour')" style="font-size: 16px; display: flex; position: relative; word-break: break-word;align-items: center;">
                                            {{getSchedulerTypeValue("every_hour")}}  <span v-if="!isEditable('every_day')" style="margin: 0px 10px;font-size: 14px;color: #757575;">min</span>  
                                        </span> 
                                        <edit-icon
                                            @click.native="editSchedulerField('every_hour');"
                                            v-if="!isEditable('every_hour')"
                                            class="edit-icon"
                                        ></edit-icon>

                                    </div>
                                    <Timepicker 
                                        v-if="isEditable('every_hour')" 
                                        v-model="selectedEveryHourValue" 
                                        format="mm" 
                                        close-on-complete 
                                        minute-label="minute"
                                        auto-scroll
                                        style="float:inline-start;"
                                        ref="addEveryHourPicker"
                                    >
                                    </Timepicker>
                                    <span v-if="isEditable('every_hour')" style="margin: 0px 10px;font-size: 14px;color: #757575;"> min</span>
                                </div>
                                <div v-if="isScheduleEditMode && isEditable('every_hour')" class="taskTitleSaveUnsaveBtns" style="height: 40px;display: inline-block;float: inline-start;">
                                    <div class="d-flex" style="height: 100%;align-items: center;">
                                    <save-icon
                                    @click.native="schedulerFieldUpdateRequest('every_hour')"
                                    ></save-icon>
                                    
                                    <cancel-icon
                                        @click.native="cancelSelectedSchedulerFields('every_hour')" >
                                    </cancel-icon>
                                    </div>
                                </div>
                            </div> 
                        </div>
                       
                        <div class="scheduler-each-field-wrapper">
                            <input v-model="scedulerTypevalue" @click="selectSchedulerType('every_minute', true)" type="radio" id="every_minute" ref="every_minute" value="every_minute" class="bg-transparent border rounded text-light bigger-checkboxes scheduler-comm-radio-btn" name="scheduler-value" checked/>
                            <span class="scheduler-comm-radio-label" for="every_minute">{{$t('Every Minute')}}</span>
                        </div>
                        <div class="scheduler-each-field-wrapper" style="height: 65px;align-items: flex-start;">
                            <input v-model="scedulerTypevalue" type="radio" ref="advanced" id="advanced" value="advanced" @click="selectSchedulerType('advanced', true)" class="bg-transparent border rounded text-light bigger-checkboxes scheduler-comm-radio-btn" name="scheduler-value"/>
                            <span class="scheduler-comm-radio-label" for="advanced">{{$t('Advanced')}}</span>
                            <template v-if="!isScheduleEditMode && isAdvancedFieldSelected">
                                <div style="width: 55%;display: inline-block;margin-inline-start:25px;">    
                                    <input v-if="isAdvancedFieldSelected" v-model="scheduledAdvancedValue" ref="advancedInputField" id="iban" name="iban"  class="rounded text-light input-fields" type="text" autocomplete="off" style="float: inline-start; width: 92%; margin-inline-start: 15px;">
                                    <span style="float: inline-start;margin: 5px 0px 0px 25px;color: #8b8b8b;">Eg: 59 23 2 4 *</span>
                                    <span> <a href="https://crontab.guru/" target="_blank" style="float: inline-end;margin: 5px 25px 0px 5px;color: #3b6ea5;">Refer formats</a> </span>
                                </div>
                                <button v-if="isEditable('advanced')" @click="verifyAdvancedValue(scheduledAdvancedValue)" class="btn btn-outline-secondary mr-3" style="float:inline-end">Verify</button>
                            </template>
                            <div v-else-if="isScheduleEditMode && isAdvancedFieldSelected" style="width:80%;display: inline-block;height:40px;float:inline-start"> 
                                <div style="display: inline-block;height:40px;float: inline-start;margin-inline-start: 25px;width:65%;float:inline-start">
                                    <div  v-if="!isEditable('advanced')" class="d-inline-flex edit-icon-visibility" style="float:inline-start;">
                                        <span v-if="!isEditable('advanced')" style="font-size: 16px; display: flex; position: relative;  margin-inline-end : 15px; word-break: break-word;align-items: center;">
                                            {{getSchedulerTypeValue("advanced")}}
                                        </span> 
                                        <edit-icon
                                            @click.native="editSchedulerField('advanced');"
                                            v-if="!isEditable('advanced')"
                                            class="edit-icon"
                                        ></edit-icon>

                                    </div>
                                    <div v-if="isEditable('advanced')" style="width: 100%;display: inline-block;">    
                                        <input v-model="scheduledAdvancedValue" ref="advancedInputField" @input="isVerified = false" class="rounded text-light input-fields" type="text" placeholder="Enter Advanced value" autocomplete="off" style="float: inline-start; width: 95%;">
                                        <span style="float: inline-start;margin: 5px 0px 0px 25px;color: #8b8b8b;">Eg: 59 23 2 4 *</span>
                                        <span> <a href="https://crontab.guru/" target="_blank" style="float: inline-end;margin: 5px 25px 0px 5px;color: #3b6ea5;">Format</a> </span>
                                    </div>    
                                </div>
                                <button v-if="isEditable('advanced') && isVerified==false" @click="verifyAdvancedValue(scheduledAdvancedValue)" class="btn btn-outline-secondary mr-3" style="float:inline-start;margin-inline-end:15px">Verify</button>
                                <div v-if="isScheduleEditMode && isEditable('advanced') && isVerified" class="taskTitleSaveUnsaveBtns" style="height: 40px;display: inline-block;float: inline-start;">
                                    <div class="d-flex" style="height: 100%;align-items: center;">
                                        <save-icon
                                        @click.native="schedulerFieldUpdateRequest('advanced')"
                                        ></save-icon>
                                        
                                        <cancel-icon
                                            @click.native="cancelSelectedSchedulerFields('advanced')" >
                                        </cancel-icon>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>  
                       
                </div>  
                <div style="display:inline-block;width:100%;">
                    <div class="col-md-8 custom-control custom-switch" style="display: inline-block;float:inline-start;text-align:start;padding:0px 20px;">
                         <h6 class="comm-scheduler-lable-style"> {{$t('Enable')}} </h6>
                         <div class="scheduler-fields-wrapper" style="position:relative;padding:10px 10px 10px 0px">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="enableScheduler"
                                ref="schedulerEnable"
                                @click="updateScheduleEnablStatus('status')"
                                :checked="!isScheduleEditMode?'true':selectedSchedulerInfo.status =='active'?true:false"
                            />
                            <label class="custom-control-label" for="enableScheduler">
                            </label> 
                        </div>    
                          
                    </div>

                </div>   
            </div>    
        </div>  
        <div v-if="!isScheduleEditMode" class="web-hook-primary-btn-style" style="padding-inline-end:15px;">
            <button v-if="!isScheduleEditMode" @click="addNewScheduler()" class="btn btn-outline-primary" style="float:inline-end">
            {{$t('Save')}}
            </button>
            <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"  v-on:click="changeToSelectedSchedulerComponent('show-scheduler', true)" style="float:inline-end">{{$t('Cancel')}}</button>
        </div> 
        
        <editCheckbox-confirm
            v-if="isCheckboxConfirmModelVisible"
            @close="closeCheckboxConfirmModal"
            :compUuid="selectedCheckboxKey"
            @saveCheckBoxedit="isCheckboxConfirmModelVisible=false; allowToUpdateField(selectedCheckboxKey)"
            ref="confirmInput"
        >
        </editCheckbox-confirm>
        <template v-if="isAdvancedFieldInstructionVisible">
            <div class="modal" tabindex="-1" role="dialog" style="display:inline-block;">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header p-2">
                            <h6 class="modal-title">Scheduler Adavnced type format</h6>
                            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="isAdvancedFieldInstructionVisible = false">
                                <span aria-hidden="true"><cancel-icon class="close-icon mt-1" style="height: 30px !important;width: 30px !important;color: #fff;"></cancel-icon>
                                </span>
                            </button>
                        </div>
                        <div class="modal-body"> 
                            <div>
                                <h6>Note</h6>
                                 <ul class="advanced-value-note-ul">    
                                    <li> * any value</li>
                                    <li> , value list separator </li>
                                    <li> -	range of values</li>
                                    <li> /	step values</li>
                                    
                                </ul> 
                            </div>   
                            <div style="width: 100%;display: inline-block;margin: 10px 0px 15px 0px;">
                                <h6 style="float:inline-start;margin-inline-end:4px"> Format </h6> <span> : Minute | Hour |  Day(month) | Month | Day(week) </span>
                            </div> 
                            <div>
                                <h6> Examples </h6>
                                <ul class="advanced-value-exapples-ul">
                                    <li><b>0 4 8-14 * *</b> : <span>At 04:00 on every day-of-month from 8 through 14</span></li>
                                    <li><b>0 0 1,15 * 3</b> : <span>At 00:00 on day-of-month 1 and 15 and on Wednesday</span></li>
                                    <li><b>5 0 * 8 *</b> : <span>At 00:00 on Sunday</span></li>
                                    <li><b>15 14 1 * *</b> : <span>At 00:05 in August</span> </li>
                                    <li><b>0 22 * * 1-5</b> : <span>At 14:15 on day-of-month 1</span></li>
                                    <li><b>23 0-20/2 * * *</b> : <span>At minute 23 past every 2nd hour from 0 through 20</span></li>
                                    <li><b>5 4 * * sun</b> : <span>At 04:05 on Sunday</span> </li>
                                    <li><b>0 0,12 1 */2 *</b> : <span>At minute 0 past hour 0 and 12 on day-of-month 1 in every 2nd month</span></li>    
                                </ul>
                            </div>      
                        </div>
                    </div>
                </div>  
                
            </div>              
        </template>
    </div>    
</template>

<script>
    import { mapActions, mapMutations } from "vuex";
    import Multiselect from 'vue-multiselect';
    import BackButton from "../core/backButton.vue";
    import Utils from "../../components.utils.js";
    import EditIcon from "../core/InlineEditField.vue";
    import SaveIcon from "../core/InlineSaveField.vue";
    import CancelIcon from "../core/InlineCancelField.vue";
    import checkboxConfrimPanel from "../core/inlineEditCheckboxConfirmDialog.vue"
    import {NotifierConstants} from "../../components.constants.js";
    import Timepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css' //timepicker styles


    export default({
        data(){
            return {
                schedulerName:"",
                schedulerNameEdited:"",
                serviceName:null,
                schedulerServicenameEdited:"",
                execution_type:"All",
                executionTypeEdited:null,
                executionTypesList : ["All", "Any"],

                scedulerTypevalue:'every_day',
                scheduledAdvancedValue:"",
                isEveryMiuteSelected:false,
                isEveryHourSelected:false,
                isEveryDaySelected:true,
                isAdvancedFieldSelected:false,
                selectedEveryHourValue:"00",
                selectedEveryDayValue:"00:00",
                isCheckboxConfirmModelVisible:false,
                selectedCheckboxKey:null,
                prevSchedulerType:'every_minute',
                editingKeyName : null,
                isAdvancedFieldInstructionVisible : false,
                isVerified:false,
            }
        },
        components: {
            "back-button":BackButton,
            "edit-icon": EditIcon,
            "save-icon": SaveIcon,
            "cancel-icon": CancelIcon,  
            "Timepicker": Timepicker,
            "editCheckbox-confirm":checkboxConfrimPanel,
            "Multiselect":Multiselect,
        }, 
        
        created(){
            this.registerforWebsocketNotifications();
            if(this.selectedSchedulerInfo && Object.keys(this.selectedSchedulerInfo).length>0){
                this.scedulerTypevalue = this.selectedSchedulerInfo.schedule_type.schedule;
                this.prevSchedulerType = this.selectedSchedulerInfo.schedule_type.schedule;
                let schedulerTypeFieldValue = this.selectedSchedulerInfo.schedule_type.value;
                this.selectSchedulerType(this.scedulerTypevalue, false, schedulerTypeFieldValue);
            }
        },
        beforeDestroy(){
            this.unRegisterforWebsocketNotifications()
        },
        props: ["selectedSchedulerName", "selectedSchedulerInfo", "isScheduleEditMode", "schedulerClassServiceListForDropDown"], 
        methods :{
            changeToSelectedSchedulerComponent(compName, isUnsavedDataCheck=false, payload={}){
                let exitPage = true;
                if( (!this.isScheduleEditMode && isUnsavedDataCheck) 
                    || (this.isScheduleEditMode && this.isAdvancedFieldSelected)
                    || (this. isScheduleEditMode && this.editingKeyName)){
                    if(!confirm(
                        `Unsaved data exists. \nYou will loose the edited data if exit from the page.`
                    )){
                        exitPage = false
                    }
                }
                if(exitPage){   
                    this.$emit("changeToSelectedSchedulerComponent", compName, payload)
                }    
            },

            allowToUpdateField(field, isClicked){
                if(field == "every_minute"){
                    if(isClicked && this.isScheduleEditMode){
                        this.schedulerFieldUpdateRequest(field);
                    }  
                }else if(field == "status"){
                    if(this.isScheduleEditMode)this.schedulerFieldUpdateRequest(field);
                }else if(field == "every_day"){
                    this.isEveryDaySelected = true;
                    if(isClicked && this.isScheduleEditMode){
                        this.schedulerFieldUpdateRequest(field);
                    }  
                }else if(field == "every_hour"){
                    this.isEveryHourSelected = true;
                    if(isClicked && this.isScheduleEditMode){
                        this.schedulerFieldUpdateRequest(field);
                    }  
                }else if(field == "advanced"){
                    this.isAdvancedFieldSelected = true;
                    this.editingKeyName = "advanced";
                }
            },

            schedulerFieldUpdateRequest(field){
                let schedulerFieldInfo = {};
                if(field == "schedule_task_name"){
                    schedulerFieldInfo[field] = this.schedulerNameEdited;
                }else if(field == "service_class"){
                    schedulerFieldInfo[field] = this.schedulerServicenameEdited;
                }else if(field == "execution_type"){
                    schedulerFieldInfo[field] = this.executionTypeEdited.toLowerCase();
                }else if(field == "status"){
                    if(this.$refs.schedulerEnable.checked == true){
                        schedulerFieldInfo[field] = "active";
                    }else{
                        schedulerFieldInfo[field] = "disabled";
                    } 
                }else if(field == "every_minute"){
                    let typeInfo={};
                    typeInfo["schedule"] = "every_minute";
                    typeInfo["value"] = "00:00";
                    schedulerFieldInfo["schedule_type"] = typeInfo;
                }else if(field == "every_hour"){
                    let typeInfo={};
                    typeInfo["schedule"] = "every_hour";
                    if(this.selectedEveryHourValue < "00"){
                        alert("Every hour value is Empty");
                        return false;
                    }
                    typeInfo["value"] = this.selectedEveryHourValue;
                    schedulerFieldInfo["schedule_type"] = typeInfo;
                }else if(field == "every_day"){
                    let typeInfo={};
                    typeInfo["schedule"] = "every_day";
                    if(this.selectedEveryDayValue < "00:00"){
                        alert("Every day value is Empty");
                        return false;
                    }
                    typeInfo["value"] = this.selectedEveryDayValue;
                    schedulerFieldInfo["schedule_type"] = typeInfo;
                }else if(field == "advanced"){
                    let typeInfo={};
                    typeInfo["schedule"] = "advanced";
                    typeInfo["value"] = this.scheduledAdvancedValue;
                    schedulerFieldInfo["schedule_type"] = typeInfo;
                }

                this.updateSchedulerFields(schedulerFieldInfo)
            },

            getSchedulerTypeValue(keyname){
                if(keyname == this.selectedSchedulerInfo.schedule_type.schedule){
                    return this.selectedSchedulerInfo.schedule_type.value;
                }else{
                    let value = "00"
                    if(keyname == "every_hour"){
                        value = "00"
                    }else if(keyname == "every_day"){
                        value = "00:00"
                    }
                    return value;
                }
            },  

            updateSchedulerFields(schedulerPutData){
                let payload = {};
                payload["schedulerId"] = this.selectedSchedulerInfo._id;
                payload.params = schedulerPutData;
                this.updateSchedulerData(payload).then((data) =>{
                    this.editingKeyName=null;
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        if(data.message) this.$toast.success(data.message);
                        this.isVerified = false;
                        if(schedulerPutData.schedule_type != "evey_hour"){
                            this.isAdvancedFieldSelected=false;
                            this.scheduledAdvancedValue = "";
                            this.selectedEveryHourValue="00";
                        }else if(schedulerPutData.schedule_type != "evey_day"){
                            this.isAdvancedFieldSelected=false;
                            this.scheduledAdvancedValue = "";
                            this.selectedEveryDayValue="00:00";
                        }else if(schedulerPutData.schedule_type != "evey_minute"){
                            this.isAdvancedFieldSelected=false;
                            this.scheduledAdvancedValue = "";
                            this.selectedEveryHourValue="00";
                            this.selectedEveryDayValue="00:00";
                        }else{
                            this.selectedEveryHourValue="00";
                            this.selectedEveryDayValue="00:00";
                        }
                    } else {
                        if(data.message) this.$toast.error(data.message);
                    }
                });
            },

            clearScheduleFieldsValue(){
                this.schedulerNameEdited="";
                this.schedulerServicenameEdited ="";
                this.scedulerTypevalue='every_minute';
                this.scheduledAdvancedValue="";
                this.isEveryMiuteSelected=false;
                this.isEveryHourSelected=false;
                this.isEveryDaySelected=false;
                this.isAdvancedFieldSelected=false;
                this.selectedEveryHourValue="00";
                this.selectedEveryDayValue="00:00";
                this.isCheckboxConfirmModelVisible=false;
                this.selectedCheckboxKey=null;
                this.prevSchedulerType='every_minute';
                this.editingKeyName = null;
                this.execution_type="All",
                this.executionTypeEdited = null;
            },

            cancelSelectedSchedulerFields(keyname){
                this.editingKeyName=null;
                if(keyname == "every_day" || keyname == "every_hour" || keyname =="every_minute" || keyname =="advanced"){
                    this.scedulerTypevalue = this.prevSchedulerType;
                    if(keyname == "every_day")this.isEveryDaySelected = false;
                    if(keyname == "every_hour")this.isEveryHourSelected = false;
                    if(keyname =="every_minute")this.isEveryMiuteSelected = false;
                    if(keyname =="advanced")this.isAdvancedFieldSelected = false;
                } 
                
            },

            onClassServiceChange(option){
                this.serviceName = option;
            },

            onExecutionTypeChange(option){
                if(!this.isScheduleEditMode){
                    this.execution_type = option;
                }else{
                    this.executionTypeEdited = option;
                }
            },   

            addNewScheduler(){
                let postData={};
                postData["schedule_task_name"] = this.schedulerName;
                if(this.serviceName == null || this.serviceName == ""){
                    alert("Select Sevice name");
                    return false;
                }
                postData["service_class"] = this.serviceName;
                postData["execution_type"] = this.execution_type.toLowerCase();
                let schedulerTypeObj = {};
                schedulerTypeObj["schedule"] = this.scedulerTypevalue;
                if(this.scedulerTypevalue == "every_minute"){
                    schedulerTypeObj["value"] = "00:00";
                }else if(this.scedulerTypevalue == "every_hour"){
                    schedulerTypeObj["value"] = this.selectedEveryHourValue;
                }else if(this.scedulerTypevalue == "every_day"){
                    schedulerTypeObj["value"] = this.selectedEveryDayValue;
                }else if(this.scedulerTypevalue == "advanced"){
                    schedulerTypeObj["value"] = this.scheduledAdvancedValue;
                }   
                postData["schedule_type"] = schedulerTypeObj;
                
                if(this.$refs.schedulerEnable.checked == true){
                    postData["status"] = "active";
                }else{
                    postData["status"] = "disabled";
                }    

                this.postNewScheduler(postData).then((data) => {
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        this.$toast.success(data.message);
                        this.clearScheduleFieldsValue();
                        this.changeToSelectedSchedulerComponent('show-scheduler');
                    } else {
                        this.$toast.error(data.message);  
                    }
                });
            },

            selectSchedulerType(eventName, isClicked, fieldValue){
                this.editingKeyName = null;
                this.scedulerTypevalue = eventName;
                this.updateScheduleTypeSelection(fieldValue);
                this.allowToUpdateField(eventName, isClicked)
              
                
            },

            isEditable(keyname){
                if(this.isScheduleEditMode){
                    return keyname === this.editingKeyName;
                }
                return true;
            },

            editSchedulerField(keyname){
                this.editingKeyName = keyname;
                if(keyname == "every_day"){
                    setTimeout(()=>{
                        if(this.$refs.addEveryDayPicker){
                            let el = this.$refs.addEveryDayPicker.$el
                            if(el)el.querySelector("input").focus();
                        }
                    },200);
                }else if(keyname == "every_hour"){
                    setTimeout(()=>{
                        if(this.$refs.addEveryHourPicker){
                            let el = this.$refs.addEveryHourPicker.$el
                            if(el)el.querySelector("input").focus();
                        }
                    },200);
                }else if(keyname == "advanced"){
                    setTimeout(()=>{
                        this.$refs.advancedInputField.focus();
                    },200) 
                }
            },

            updateScheduleTypeSelection(fieldValue){
                switch(this.scedulerTypevalue){
                    case 'advanced':{
                        this.isEveryMiuteSelected=false;
                        this.isEveryHourSelected=false;
                        this.isEveryDaySelected=false;
                        this.isAdvancedFieldSelected=true;
                        if(fieldValue){
                            this.scheduledAdvancedValue = fieldValue;
                        }
                        setTimeout(()=>{
                            this.$refs.advancedInputField.focus();
                        },200)    
                        break;
                    } 
                    case 'every_minute':{
                        this.isEveryMiuteSelected=true;
                        this.isEveryHourSelected=false;
                        this.isEveryDaySelected=false;
                        this.isAdvancedFieldSelected=false;
                        break;
                    }   
                    case 'every_hour':{
                        this.isEveryMiuteSelected=false;
                        this.isEveryHourSelected=true;
                        this.isEveryDaySelected=false;
                        this.isAdvancedFieldSelected=false;   
                        if(fieldValue){
                            this.selectedEveryHourValue = fieldValue;
                        }
                        setTimeout(()=>{
                            if(this.$refs.addEveryHourPicker){
                                let el = this.$refs.addEveryHourPicker.$el
                                if(el)el.querySelector("input").focus();
                            }
                        },200);
                        break;
                    } 
                    case 'every_day':{
                        setTimeout(()=>{
                            if(this.$refs.addEveryDayPicker){
                                let el = this.$refs.addEveryDayPicker.$el
                                if(el)el.querySelector("input").focus();
                            }
                        },200);
                        this.isEveryMiuteSelected=false;
                        this.isEveryHourSelected=false;
                        this.isEveryDaySelected=true;
                        this.isAdvancedFieldSelected=false;
                        if(fieldValue){
                            this.selectedEveryDayValue = fieldValue;
                        }
                        break;
                    }  
                    default:
                    break; 
                }
            },

            updateScheduleEnablStatus(status){
                if(this.isScheduleEditMode){
                    // this.isCheckboxConfirmModelVisible = true;
                    this.selectedCheckboxKey = status;
                    this.allowToUpdateField(this.selectedCheckboxKey)
                }
            },

            closeCheckboxConfirmModal(){
                this.isCheckboxConfirmModelVisible=false;
                if(this.selectedCheckboxKey == "status"){
                    this.$refs.schedulerEnable.checked = !this.$refs.schedulerEnable.checked;
                }
            },

            verifyAdvancedValue(value){
                if(value == ""){
                    alert("Empty Advanced Value")
                    return false;
                }
                if(value){
                    let verifyPostData ={};
                    verifyPostData["cron_line"] = value;
                    this.postAdvancedValueToVerify(verifyPostData).then((data) => {
                        if (Utils.isAcceptedStatusCode(data.statusCode)) {
                            if(data.parsed == false){
                                setTimeout(()=>{
                                    this.$refs.advancedInputField.focus();
                                },200) 

                                this.$toast.error(data.error)
                            }else{
                                this.$toast.success("Verification Succed")
                                this.isVerified = true;
                            }   
                        } else {
                            this.$toast.error(data.message);  
                            setTimeout(()=>{
                                this.$refs.advancedInputField.focus();
                            },200) 
                        }
                    });
                }
            },

            handleWebHookNotification(notification){
                 notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                let messageInfo = notification.message;
                if (notification.message_type == NotifierConstants.schedulerUpdateNotification){
                    if(this.selectedSchedulerInfo._id == messageInfo.schedule_task_id){
                        if(Object.keys(messageInfo).includes("schedule_task_name")){
                            this.$set(this.selectedSchedulerInfo, "schedule_task_name", messageInfo.schedule_task_name)
                            this.schedulerNameEdited = messageInfo.schedule_task_name;
                        }

                        if(Object.keys(messageInfo).includes("service_class")){
                            this.$set(this.selectedSchedulerInfo, "service_class", messageInfo.service_class)
                            this.schedulerServicenameEdited = messageInfo.service_class;
                        }

                        if(Object.keys(messageInfo).includes("execution_type")){
                            this.$set(this.selectedSchedulerInfo, "execution_type", messageInfo.execution_type)
                            this.executionTypeEdited = messageInfo.execution_type;
                        }

                        if(Object.keys(messageInfo).includes("schedule_type")){
                            this.$set(this.selectedSchedulerInfo, "schedule_type", messageInfo.schedule_type)
                            this.schedulerServicenameEdited = messageInfo.service_class;

                            if(messageInfo.schedule_type.schedule == "Schedule.EVERY_MINUTE"){
                               this.scedulerTypevalue = "every_minute"
                               this.prevSchedulerType = "every_minute"
                            }else if(messageInfo.schedule_type.schedule == "Schedule.EVERY_HOUR"){
                               this.scedulerTypevalue = "every_hour"
                               this.prevSchedulerType = "every_hour"
                               this.selectedEveryHourValue = messageInfo.schedule_type.value;
                            }else if(messageInfo.schedule_type.schedule == "Schedule.EVERY_DAY"){
                               this.scedulerTypevalue = "every_day"
                               this.prevSchedulerType = "every_day"
                               this.selectedEveryDayValue = messageInfo.schedule_type.value;
                            }else if(messageInfo.schedule_type.schedule == "Schedule.ADVANCED"){
                               this.scedulerTypevalue = "advanced"
                               this.prevSchedulerType = "advanced"
                               this.selectedEveryDayValue = messageInfo.schedule_type.value;
                            }
                        }
                        
                    } 
                }    
            },    

            registerforWebsocketNotifications(){
                this.addWSEventListener({
                    eventname:[NotifierConstants.schedulerCreateNotification, NotifierConstants.schedulerUpdateNotification, NotifierConstants.schedulerDeleteNotification],
                    callback:this.handleWebHookNotification,
                    parent: "scheduler"});
            },

             unRegisterforWebsocketNotifications(){
                this.removeWSEventListener({
                    eventname:[NotifierConstants.schedulerCreateNotification, NotifierConstants.schedulerUpdateNotification, NotifierConstants.schedulerDeleteNotification],
                    callback:this.handleWebHookNotification,
                    parent: "scheduler"});
             },

            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapActions("schedulerTask", ["postNewScheduler", "updateSchedulerData", "postAdvancedValueToVerify"])
        }
    });            
</script> 

<style lang="scss" scoped>

    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $button-height:38px;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
    $icon-hover:#2c3339;    

    .modal-dialog {
        max-width: 670px !important;
        width: 670px !important;
        height: 500px;
        margin: 0;
        padding: 0;
    }
  
    .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            height: 130px;
            overflow: auto;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: block;
        position: fixed;
        inset-inline-start: 0px;
        top: 20%;
    }
    .modal:before {
        content: "";
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height:58px;
        .modal-title{
            color:$text-color;
            padding: 2%;
        }
    }

    .modal-header .close {
        margin: 0px !important;
    }
    button.close {
        padding: 0;
        background-color: transparent;
        border: 0;
    }

    ul{
        list-style-type: none;
    }

    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }

    .input-fields{
        background: #1a1e21!important;
        height: 40px;
        float: inline-end;
        padding-inline-start: 12px;
        margin: 0 3% 0 0;
        padding-bottom: 2px;
        border: $border-color;
    }

    .custom-control-input{
        z-index:999;
    }

    .category-label {
        padding-top: 2px;
        font-weight: 600;
        display: block !important;
    }

    .category-head {
        float: inline-start;
        text-align: initial;
        width: 100%;
    }

    .custom-control-label::before, .custom-file-label, .custom-select {
        transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }

    .config-desc{
        color: $dull-text-color;
    }

    .text-color{
    color:$dull-text-color;
    }

    .bigger-checkboxes{
        height: 30px;
        width: 20px;
    }

    input[type="radio"] {
        outline: none !important;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        display: inline-block;
        padding: 4px;
        border-radius: 50% !important;
        width: 20px;
        height: 20px;
    }

    input[type='checkbox']:after{
        line-height: 1.5em;
        content: '';
        display: inline-block;
        width: 22px;
        height: 21px;
        margin-top: 5px;
        margin-inline-start: -1px;
        border: $border-color;
        border-radius: 0.25em;
        background: $primary-background;
    }

    input[type='checkbox']:checked:after{
        content: '✔';
        color: $active-blue !important;
        // position: absolute;
        font-size: 16px;
        line-height: 1;
        transition: all .2s;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px;
        padding-top:2px;
    }


    input[type="radio"] {
        /* background-color only for content */
        background-color:$primary-background !important;
    }
    
    /* appearance for checked radiobutton */
    input[type="radio"]:checked {
        background-color: $active-blue !important;
        //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
        background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
        border: 1px solid #909090 !important;

    }

    .custom-control-input {
        position: absolute;
        inset-inline-start: 0;
        z-index: -1;
        width: 1rem;
        height: 1.25rem;
        opacity: 0;
    }

    .comm-field-div{
        display: inline-block;
    }

    .edit-icon{
        visibility: hidden;
    }

    .edit-icon-visibility{
        width: 100%;
    }

    .edit-icon-visibility:hover{
        .edit-icon{
            visibility: visible;
        } 
    }

    .breadcrumb{
        padding: 0.75rem 1rem !important;
        background: #1a1e21 !important;
    }

    .activeTab{
        background: #272727 !important;
        color: $text-color!important;
        font-weight: 500;
        font-size:15px;
        color: #fff !important;
    }

    .web-hook-primary-btn-style {
        margin-top: 1%;
        // position: absolute;
        // bottom: 6px;
        inset-inline-end: 0%;
        height:50px;
        background: $primary-background;
        width:100%;
        z-index:9;
        button {
            height: $button-height;
            width: 70px;
            font-size:14px;
            margin-top:7px;
        }
        .btn-outline-secondary{
            float:inline-end;
        }
        .btn-outline-primary{
            float:inline-end;
            margin-inline-end:15px;
        }
    }

    .custom-switch{
      padding-inline-start: 5%;
    }
    
    .custom-control-label::before {
        background-color: $primary-background;
        inset-inline-start:0px !important;
    }

    .custom-control-label::after{
        inset-inline-start:1px !important;
    }

    .comm-scheduler-lable-style{
        width: 120px;
        display: flex;
        float: inline-start;
        height: 40px;
        align-items: center;
        margin: 0px 5px;
        text-align: center;
        color: $dull-text-color;
        justify-content: end;
        margin-inline-end: 15px;
    }

    .scheduler-fields-wrapper{
        display: inline-block;
        width: 60%;
        float: inline-start;
        align-items: center;
        .scheduler-each-field-wrapper{
            width: 100%;
            display: inline-flex;
            align-items: center;
            padding: 5px;
            height:45px;
            .scheduler-comm-radio-btn{
                float: inline-start;
            }
            .scheduler-comm-radio-label{
                float: inline-start;
                margin-inline-start:10px;
            }
        }    
    }

    .advanced-value-exapples-ul{
        margin-inline-start: 25px;
        li{
            padding: 8px;
            color: #bebebe;
            b{
                width: 20%;
                display: inline-block;
                text-align: end;
                margin-inline-end: 5px;
            }
            span{
                width: 75%;
                display: inline-block;
                margin-inline-start: 5px;
                text-align: start;
            }
        }
    }

    .advanced-value-note-ul{
        margin-inline-start: 25px;
        li{
            padding: 8px;
            color: #bebebe;
            font-style: italic;
        }
    }

    .comm-at-label{
        width: 30px;
        display: inline-block;
        margin: 0px 15px;
        color: $dull-text-color;
    }

    ::-webkit-scrollbar {
      width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

    ::-webkit-input-placeholder { /* Edge */
        color: red;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: red;
    }

    .input-fields::placeholder {
        color: #545454 !important;
    }

    .placed-edit-icon{
        background: #d1d2d31a;
        padding: 4px;
        height: 40px;
        width: 40px;
        border-radius: 4px;
    }

    .placed-edit-icon:hover{
        background: #fdfeff54 !important;
        svg{
            fill:#fff;
        }
    }

     ::v-deep {
        .vue__time-picker input.display-time {
            border: $border-color;
            width: 10em;
            height: 40px;
            padding: 0.3em 0.5em;
            font-size: 1em;
            border-radius: 5px;
            color: #fff;
        }

        .vue__time-picker-dropdown ul li, .vue__time-picker .dropdown ul li {
            list-style: none;
            text-align: center;
            padding: 0.3em 0;
            color: #ddd;
            font-size:14px !important;
        }

        .vue__time-picker .dropdown ul li:not([disabled]).active{
            background: #017bff !important;
            color: #fff !important;
        }

        .vue__time-picker-dropdown, .vue__time-picker .dropdown {
            border: $border-color !important;
            background: $primary-background;
        }    

        .vue__time-picker-dropdown ul li:not(.hint):not([disabled]):focus, 
        .vue__time-picker-dropdown ul li:not(.hint):not([disabled]):hover, 
        .vue__time-picker .dropdown ul li:not(.hint):not([disabled]):focus, 
        .vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover,
        .vue__time-picker .dropdown ul li:not(.active):not([disabled]):hover,
        .vue__time-picker .dropdown ul li:not(.active):not([disabled]):focus{
            background: #505050;
            color: #fff !important;
            cursor: pointer;
        }
        
        .vue__time-picker .dropdown ul.minutes, .vue__time-picker .dropdown ul.seconds {
            border-inline-start: $border-color;
        }

        .mx-input{
            background-color:$primary-background !important;
            border: none !important;
            color: #eee !important;
            height:100%;
        }
        .mx-input-wrapper{
        width:100%;
        height:100%;
        }
        .mx-datepicker-main{
            border: $border-color !important;
            background: $primary-background !important;
        }
        .mx-calendar-content .cell:hover{
            background-color: #505050 !important;
        }
        .mx-datepicker-range{
        width:100%;
        height:100% !important;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-datepicker{
        width:100% !important;
        padding: 0 !important;
        border:$border-color !important;
        height: 27px !important;
        }
        .mx-icon-calendar, .mx-icon-clear{
            color: #d7d2d280;
        }

       .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-end;
            margin-inline-start:5px;
            position: relative;
            top:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }

        .multiselect {
            width:100%;
            margin: 3px 0px;
            color:$text-color;
            cursor:auto;
        }
        .multiselect__tags-wrap{
            display: block !important;
        }
        .multiselect__content-wrapper {
            display: none;
        }
        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
            background: $primary-background !important;
                border: $border-color !important;
        }

        .name-count-parent-wrap{
            background: transparent !important;
            border: none !important;
        }

        
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input,
        .multiselect__single {
            background: transparent !important;
            color: $text-color;
        }
        .multiselect__input:focus {
            outline: none;
            box-shadow: none;
        }
        .multiselect__tag-icon {
            color: $text-color !important;
        }
        .multiselect__tag-icon:focus,
        .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after {
            color: $secondary-text-color !important;
            font-size: 23px;
        }

        .multiselect__tag-icon {
            visibility: hidden;
        }

        .multiselect__tag:hover .multiselect__tag-icon {
            visibility: visible;
        }

        .multiselect * {
            font-size: $input-field-and-label-font-size !important;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__placeholder {
            padding-top: 3px !important;
            margin-bottom:0px !important;
        }
        .multiselect {
            color: $text-color !important;
            font-size: $input-field-and-label-font-size !important;
            width: 100%;
            min-height: 38px;
        }
        .multiselect__single {
            padding-top: 3px;
        }
        .multiselect__option--selected {
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper {
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 240px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }

        .multiselect__current,
        .multiselect__option {
            line-height: 12px !important;
        }

        .multiselect--above .multiselect__content-wrapper {
            background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background !important;
            height: auto !important;
            padding: 8px 40px 8px 8px !important;
            min-height: 40px !important;
        } 
    }

</style>    